import React,{useEffect,useRef} from "react";
import NavBar from "../components/NavBar";
import Bar from "../components/Bar";
import DetailsBar from "../components/DetailsBar";
import FAQ2 from "../components/FAQ2";
import RedBanner from "../components/RedBanner";
import Footer from "../components/Footer";
import Required from "../components/Required";
import SmoothScroll from "../components/Lenis";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Poland =()=>{
    SmoothScroll();

    const sec1 = useRef(null);
    const sec2 = useRef(null);
    const sec3 = useRef(null);

    useEffect(() => {
        gsap.set(sec1.current, { opacity: 0, y: 100 });
        gsap.set(sec2.current, { opacity: 0, y: 100 });
        gsap.set(sec3.current, { opacity: 0, y: 100 });

        gsap.to(sec1.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec1.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });

        gsap.to(sec2.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec2.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });

        gsap.to(sec3.current, {
            opacity: 1,
            y: 0,
            duration: 2,
            scrollTrigger: {
                trigger: sec3.current,
                start: "top 100%",
                end: "bottom top",
                toggleActions: "play none none none",
            },
        });
    },[]);

    return(
        <div className="bg-black overflow-hidden">
            <NavBar />
            <section className="w-full font-guton pt-16 md:pt-28 bg-whiteExtra pb-20">
                <div  className="flex w-90 mx-auto flex-col items-center pb-10 max-w-[1440px]">
                    <Bar />
                    <h1 ref={sec1} className="text-42 md:text-52 xl:text-80 font-semibold text-center w-95 md:w-75 xl:leading-70 mb-0 mt-4 xl:mt-10 xl:mb-4 tracking-[-3px]">Study in <span className="pr-1 bg-custom-gradient text-transparent bg-clip-text">POLAND</span></h1>
                    <p ref={sec2} className="text-12 md:text-16 text-center xl:text-24 leading-12 md:leading-16 xl:leading-22 tracking-[-0.7px] xl:tracking-[-1.2px] w-85 xl:w-75">Study in Poland and Experience World-Class Education, Rich Culture, and Endless Opportunities for Growth. <strong>We’re here to support you every step of the way.</strong></p>
                </div>
            </section>
            <DetailsBar />
            <Required />
            <FAQ2 />
            <RedBanner />
            <Footer />

        </div>
    )
}

export default Poland;